import { NgModule } from "@angular/core";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { Address } from "ngx-google-places-autocomplete/objects/address";
import { AddressComponent } from "ngx-google-places-autocomplete/objects/addressComponent";

@NgModule({
    imports: [GooglePlaceModule],
    exports: [],
  })
export class GooglePlacesUtil {

    static findAddressComponentByType( addr : Address, type : string ) : string {
        let comp : AddressComponent = addr.address_components.find((item : AddressComponent) => item.types.indexOf(type) >= 0) as AddressComponent;
        return comp ? comp.short_name : "";
    }

}
